import Hero from '../components/Hero';
import Dashboard from '../components/Dashboard';
import Features from '../components/Services';
import Contact from '../components/Contact';
//import Pricing from '../components/Pricing';
//import About from '../components/About';

const Home = (): JSX.Element => {
  return (
    <div id='home'>
      <Hero />
      <Dashboard />
      <Features />
      <Contact />
    </div>
  );
};

export default Home;
